export const toInt = (n) => Number.parseInt(n, 10);
//# sourceMappingURL=num.js.map